<template>
  <div v-if="is_load">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/">Главная</a></li>
        <li class="breadcrumb-item"><a href="/shop">На продажу</a></li>
        <li class="breadcrumb-item active" aria-current="page">Корзина</li>
      </ol>
    </nav>
    <section class="section section section-shaped my-0 overflow-hidden content_background_color_blue2">
      <div class="shape shape-style-1 bg-gradient-warning ">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>

      </div>

      <div class="container py-0 ">
        <div class="row row-grid mb-5 align-items-center">
          <card class="col-12"  >
            <h2> Корзина  </h2>
            <div class="col-12"  v-if="Object.keys(cart).length>0" >
              <div v-if="cart.length>0 && Object.keys(cart).length>0" class="row col-12 alert alert-success" v-for="(item,item_key) in cart" :key="item_key"
              >
                <div class="col-l-12 col-md-4 col-lg-4" v-if="item"><a :href="'/shop/item/'+item.last_id" class="btn side4">{{ item.title}}</a></div>
                <div class="col-l-12 col-md-4 col-lg-4" v-if="item">{{ item.price}} {{ item.currency}}</div>
                <div class="col-l-12 col-md-4 col-lg-4" v-if="item">
                  <p    v-for="(option,option_key) in item.options" :key="option_key">
                    <b v-if="  item.custom_options.length>0 && item.custom_options[option_key]!=null   && item.custom_options[option_key]==true   "> {{ option.title}} +{{ option.price}} {{item.currency}}</b>
                  </p>
                  <p>{{ item.custom_price }} * {{ item.count}}= {{ parseInt(item.custom_price) * parseInt(item.count)}} {{ item.currency}}</p>
                  <p><input type="number"  @change="changeCount(item_key)" class="form-control"   v-model="cart[item_key]['count']"></p>
                  <p><button class="btn btn-danger" type="submit" @click="deleteItem(item_key)">Удалить</button></p>
                </div>


              </div>
              <div  v-if="cart.length>0 && Object.keys(cart).length>0 "class=" col-12">
                <p>Итого:</p>
                <p v-for="(one_total,total_key) in total" :key="total_key" v-if="one_total>0">{{ one_total }} {{ total_key}}</p>
                <div class="alert alert-danger" v-if="is_error">
                  <p>{{ error_message}}</p>
                </div>

                <div v-if="fields.length>0" class="row col-12 alert alert-success" v-for="(field,field_key) in fields" :key="field_key"
                >
                  <div class="col-12 col-lg-6">{{ field.title}}</div>
                  <div class="col-12 col-lg-6">
                    <input v-if="field.type=='stroka'" type="text"  class="form-control" v-model="order_data[field.name]"/>
                    <input v-if="field.type=='number'" type="number"  class="form-control" v-model="order_data[field.name]"/>
                    <select v-if="field.type=='select'" class="form-control" v-model="order_data[field.name]">
                      <option v-if="field.options.length>0"   v-for="(option,option_key) in field.options" :value="option" :key="option_key"
                      >{{ option }}</option>
                    </select>
                  </div>
                  </div>

                <p><button class="btn side2" v-if="islogin==false" @click="callModalLogin">
                  Войдите чтобы создать заказ
                </button></p>

                <p><button type="submit" v-if="islogin==true" class="btn btn-danger" @click="createOrder()">Создать заказ</button></p>
              </div>
            </div>


          </card>






        </div>
      </div>
    </section>
  </div>
</template>

<script>

import Api from "../../models/Api";
import Vue from "vue";
import Editorjsrender from "@/models/Editorjsrender";
import {eventBus} from "@/main";



var Avatar = require('vue-avatar');


export default {
  name: 'Cart',

  components: {
    'editorjsrender': Editorjsrender,
  },
  data() {
    return {
      "cart":null,
      "is_load":false,
      'user':null,

      "islogin":false,
      "total":null,
      "is_error":false,
      "error_message":null,
      "fields":[],
      "order_data":{},
    }
  },
  mounted() {

    var app=this;
    if (app.$store.getters.ISAUTH) {
      var tmpUser = app.$store.getters.USER;

      app.user = tmpUser;
      app.islogin = true;


    }

    eventBus.$on('user_is_login', user => {
      this.islogin = false;
      if (typeof user === 'object') {
        if (user.api_token) {
          app.user = user;
          app.islogin = true;

        }
      }


    });

    Api.loadShopFields(function(data){
      app.cart=Api.getCart();
      app.total=Api.getTotalPrice();

      if(data.fields.length){
        var i=0;
        while(data.fields[i]){
          var current_field=data.fields[i];
          app.order_data[current_field.name]="";

          i++;
        }
        app.fields=data.fields;
      }



      app.is_load=true;
    })




  },
  methods: {
    changeCount(item_key){

      var app=this;
      var cart=app.cart;
      if(cart[item_key]['count']==0){
        cart[item_key]['count']=1;
      }


      Api.setCart(cart);
      app.cart=cart;




      app.total={};
      app.total=Api.getTotalPrice();
      Api.syncCart();
    },
    changeOptions(key){
      var app=this;
      var custom_price=parseInt(app.item.price);
      if(app.item.options.length>0){
        app.item.options.forEach(function(item, i, arr) {
          console.log(app.custom_options[i]);
          if(app.custom_options[i]){
            custom_price+=parseInt(item.price);
            app.custom_price=custom_price;
          }
        });

      }
    },
    deleteItem(item_key){

      var app=this;

      Vue.delete(this.cart, item_key);
       Api.setCart(app.cart);
      app.total={};
      app.total=Api.getTotalPrice();
      Api.syncCart();
    },
    callModalLogin() {
      eventBus.$emit("call_modal_add_project", {type: "login",})
      {

      }
    },
    createOrder(){
      var app=this;
      var cart=app.cart;
      var params={};
      params.cart=cart;
      params.client_data=app.order_data;
      Api.createShopOrder(params,function(){
        Api.setCart([]);
        Api.syncCart();
        app.$router.push({path: "/invoices"});

        app.is_error=false;
      },function(message){
      app.is_error=true;
      app.error_message=message;
      })
    }




  }
};
</script>
